import React from "react";
import Product_Details_Management_Edit from "./SubComponents/Product_Details_Management_Edit";
import Product_Details_forms_Edit from "./SubComponents/Product_Details_forms_Edit";
import Assigned_Details_Edit from "./SubComponents/Assigned_Details_Edit";
import Self_Life_forms_Edit from "./SubComponents/Self_Life_forms_Edit";
import File_Attachment_Form_Edit from "./SubComponents/File_Attachment_Form_Edit";
import Description_About_Product_Forms_edit from "./SubComponents/Description_About_Product_Forms_edit";

function Product_Details_Edit_SubComponent() {
  return (
    <div className="px-10 space-y-5">
      <Product_Details_Management_Edit />
      <Product_Details_forms_Edit />
      <Assigned_Details_Edit />
      <Self_Life_forms_Edit />
      <File_Attachment_Form_Edit />
      <Description_About_Product_Forms_edit />
    </div>
  );
}

export default Product_Details_Edit_SubComponent;
